import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

import * as process from './process'

@ngCore.Component({
  imports: [process.Component, ds.illustration.emptyState.Component],
  selector: 'atn-process-list',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link platform.ProcessEcService} */
  public readonly processEc = ngCore.inject(state.relay.processes.Collection)

  /** @see {@link state.relay.processes.plugins.polling.Plugin} */
  public readonly pollingPlugin = this.processEc.plugins
    .lookup(state.relay.processes.plugins.polling.Plugin)
    .get()

  /** List of {@link ents.core.relay.processes.Process.WithDetails} */
  public processesSg = ngCore.computed(() =>
    this.processEc.plugins.currentListPlugin.feature.selectors.entities
      .asSignal()
      .map(processesEssentials =>
        ents.core.relay.processes.Process.WithDetails.from(processesEssentials),
      )
      // Sorting processes by time
      .sort((a, b) => b.date.getTime() - a.date.getTime()),
  )

  /**
   * Handles error and empty state action click to refresh the processes
   */
  public refreshProcessesHandler(source: 'EmptyState' | 'ErrorState'): void {
    this.processEc.plugins.currentListPlugin.feature.actions.load
      .from(`ProcessesSlideout.${source}.Action.Clicked`)
      .dispatch()
  }
}
